import { render, staticRenderFns } from "./TravelPlanningTravelHabits.vue?vue&type=template&id=6e55885f&scoped=true&"
import script from "./TravelPlanningTravelHabits.vue?vue&type=script&lang=ts&"
export * from "./TravelPlanningTravelHabits.vue?vue&type=script&lang=ts&"
import style0 from "./TravelPlanningTravelHabits.vue?vue&type=style&index=0&id=6e55885f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e55885f",
  null
  
)

export default component.exports